/*
 * Author: Ben Zhao
 * File Created: Wednesday, 25-06-18 10:34 am
 * Last Modified: Wednesday, 25-06-18 10:59 am, by Ben Zhao
 */

import { showStatusDialog } from '@ucard/ds/message';
import type { StatusDialogProps } from '@ucard/ds/message/dialog/templates';

import { TaskQueue } from '@web/utils';

class ModalController extends TaskQueue {
  constructor() {
    super(800);
  }

  pushStatusModal(
    modalConfig: Omit<StatusDialogProps, 'open'>,
    priority: number,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression -- ignore
    const task = this.push({
      task: {
        onFetched: () => {
          return new Promise((resolve) => {
            const close = showStatusDialog({
              ...modalConfig,
              onClose: () => {
                modalConfig.onClose?.();
                resolve(false);
              },
              btn1: {
                ...modalConfig.btn1,
                // @ts-expect-error -- ignore
                onClick: (e) => {
                  modalConfig.btn1?.onClick?.(e);
                  resolve(true);
                  close();
                },
              },
              btn2: {
                ...modalConfig.btn2,
                // @ts-expect-error -- ignore
                onClick: (e) => {
                  modalConfig.btn2?.onClick?.(e);
                  resolve(true);
                  close();
                },
              },
            });
          });
        },
      },
      priority,
    });

    return task;
  }
}

export const initModalManager = new ModalController();
